import { SelectOptionType } from '@octano/global-ui';

export interface FirstInstallmentRule {
  id: number;
  code: string;
  name: string | null;
  data: {
    date?: string;
    month?: string;
    day?: string;
    validity?: number;
  };
}

export enum AdmissionScope {
  OS = 'OS',
  OL = 'OL',
}

export interface FirstInstallmentRuleFormValues {
  firstInstallmentRule: SelectOptionType | null;
  selectDay: string | null;
  selectMonth: SelectOptionType | null;
  selectDate: string | null;
  validityRange: string | null;
  selectYear: SelectOptionType | null;
}

export interface OfferListFormValues extends FirstInstallmentRuleFormValues {
  enrollmentType: SelectOptionType | null;
  maxInstallments: SelectOptionType | null;
  quota: string | null;
  offerQuota: string | null;
}

export interface Offer {
  admissionId: number;
  admissionScopes: AdmissionScope[];
  campusName: string;
  duration: string | null;
  scheduleName: string;
  startDate: string | null;
  studyPlanName: string;
  subprocessId: number;
  quota: number | null;
  offerQuota: number | null;
  offerId?: number;
  admissionViaId: string | null;
  admissionViaName: string | null;
  isUsed?: boolean;
}

export interface AdmissionProcess {
  id: number;
  name: string;
  startedAt: string;
  endedAt: string;
  isEnabled: boolean;
  isMultiTuition: boolean;
  tuitionProcessTypeId: number;
  tuitionProcessTypeName: string;
  academicOfferId: number;
  periodName: string;
  firstInstallmentRule: FirstInstallmentRule | null;
  maxInstallments: number | null;
  payday: number | null;
  stages: any[];
  offers: Offer[];
  academicOfferQuota: number;
  totalAllocatedQuota: number;
}

export enum FirstInstallmentRuleKeys {
  SPECIFIC_DATE = 'specificDate',
  SPECIFIC_MONTH_DAY = 'specificMonthDay',
  NEXT_MONTH = 'nextMonth',
  NEXT_MONTH_DAY = 'nextMonthDay',
}

export interface AdmissionViaOption {
  id: string;
  name: string;
  deductsOfferQuota: boolean;
}

export interface AvailableOffer {
  id: number;
  studyPlanName: string;
  campusName: string;
  scheduleName: string;
  startDate: string | null;
  duration: string | null;
  offerQuota: number | null;
  availableViaIds: string[];
  isSaturated: boolean;
  allocatedQuota: number;
}

export interface AvailableOffersResponse {
  offers: AvailableOffer[];
  admissionVias: AdmissionViaOption[];
}

export interface ProcessUpdateBody {
  startDate: string | null;
  duration: string | null;
  admissionScopes: AdmissionScope[] | null;
  maxInstallments: number | null;
  firstInstallmentRuleValue: {
    key: string;
    value: any;
    firstInstallmentRuleId?: number;
  };
  tuitionProcessFirstInstallmentRuleId?: number;
}

export interface BulkAdmissionRow {
  rowKey: string;
  id?: number;
  offerId: number;
  quota?: number;
  admissionScopes?: AdmissionScope[];
  admissionViaId?: string | null;
}

export interface BulkAdmissionsBody {
  upserts: BulkAdmissionRow[];
  deletes: number[];
}

export interface BulkPreviewRowResult {
  rowKey: string;
  action: 'create' | 'update' | 'delete' | 'noop';
  errors: string[];
  warnings: string[];
  resolvedAdmissionViaId: string | null;
}

export interface BulkPreviewResult {
  rows: BulkPreviewRowResult[];
  summary: {
    totalAllocatedQuota: number;
    totalSeparateQuota: number;
    academicOfferQuota: number | null;
    hasErrors: boolean;
    hasWarnings: boolean;
  };
}
